<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>

    <!-- 基本信息 -->
    <div class="mgb-20">基本信息</div>
    <el-table :data="basicTableData" border style="width: 100%">
      <el-table-column prop="customerNum" label="客户编号"> </el-table-column>
      <el-table-column prop="customerPhone" label="客户电话"> </el-table-column>
      <el-table-column label="客户类型">
        <template slot-scope="scope">
          <span
            v-text="scope.row.customerPhone ? '电子水卡用户' : '实体水卡用户'"
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="loginCount" label="登陆次数"> </el-table-column>
      <el-table-column prop="addTime" label="创建时间"> </el-table-column>
      <el-table-column prop="updateTime" label="上次登录时间">
      </el-table-column>
    </el-table>

    <!-- 订单信息 -->
    <div class="mgt-20 mgb-20">消费信息</div>
    <el-table :data="orderTableData" border style="width: 100%">
      <el-table-column prop="orderPrice" label="账户有效余额(赠送/实付)">
        <template slot-scope="scope">
          <span
            v-text="
              (
                Number(scope.row.currentBalancePay) +
                Number(scope.row.currentBalanceSend)
              ).toFixed(2) +
                '(' +
                scope.row.currentBalanceSend +
                '/' +
                scope.row.currentBalancePay +
                ')'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="rechargeNum" label="充值总次数"> </el-table-column>
      <el-table-column prop="orderNum" label="充值总金额(赠送/实付)">
        <template slot-scope="scope">
          <span
            v-text="
              (
                Number(scope.row.rechargeReal) + Number(scope.row.rechargeGive)
              ).toFixed(2) +
                '(' +
                scope.row.rechargeGive +
                '/' +
                scope.row.rechargeReal +
                ')'
            "
          ></span>
        </template>
      </el-table-column>

      <el-table-column prop="orderNum" label="消费总次数"> </el-table-column>
      <el-table-column prop="refundPrice" label="消费总金额(赠送/实付)">
        <template slot-scope="scope">
          <span
            v-text="
              (
                Number(scope.row.discountPrice) + Number(scope.row.payPrice)
              ).toFixed(2) +
                '(' +
                scope.row.discountPrice +
                '/' +
                scope.row.payPrice +
                ')'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="orderWater" label="取水总量(L)">
        <template slot-scope="scope">
          <span
            v-text="scope.row.orderWater ? scope.row.orderWater / 1000 : 0"
          ></span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 近12月消费趋势 -->
    <!-- <div class="mgt-20 mgb-20">近12月消费趋势</div>
    <el-form
      :inline="true"
      ref="monthForm"
      :model="monthForm"
      label-width="80px"
    >
      <el-form-item label="所属企业">
        <el-select
          v-model="monthForm.qiye"
          filterable
          clearable
          placeholder="全部"
        >
          <el-option
            v-for="v in qiyeArr"
            :key="v.id"
            :label="v.companyName"
            :value="v.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属区域">
        <el-select
          v-model="monthForm.fenqu"
          filterable
          clearable
          placeholder="全部"
        >
          <el-option
            v-for="(v, i) in zoneArr"
            :key="i"
            :label="v.regionName"
            :value="v.id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button>重置</el-button>
      </el-form-item>
    </el-form>

    <el-descriptions title="充值笔数" column="12">
      <el-descriptions-item label="用户名">kooriookami</el-descriptions-item>
    </el-descriptions>
    <el-descriptions title="充值金额(赠送/实付)" column="12" class="mgt-10">
      <el-descriptions-item label="用户名">kooriookami</el-descriptions-item>
    </el-descriptions>
    <el-descriptions title="消费笔数" column="12" class="mgt-10">
      <el-descriptions-item label="用户名">kooriookami</el-descriptions-item>
    </el-descriptions>
    <el-descriptions title="消费金额(赠送/实付)" column="12" class="mgt-10">
      <el-descriptions-item label="用户名">kooriookami</el-descriptions-item>
    </el-descriptions>
    <el-descriptions title="取水总量" column="12" class="mgt-10">
      <el-descriptions-item label="用户名">kooriookami</el-descriptions-item>
    </el-descriptions> -->

    <!-- 负责员工 -->
    <div class="mgt-20 mgb-20">
      <span class="mgr-30">负责员工</span>
      <span
        >说明：首次为用户充值的员工会自动生成员工与客户之间的绑定关系。</span
      >
    </div>
    <el-table :data="staffTable" border stripe style="width: 100%">
      <el-table-column
        type="index"
        :index="indexMethod2"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="regionName" label="所属区域"> </el-table-column>
      <el-table-column prop="salesName" label="负责员工"> </el-table-column>
      <el-table-column prop="salesPhone" label="员工电话"> </el-table-column>
      <el-table-column prop="createTime" label="绑定时间"> </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange2"
      @current-change="handleCurrentChange2"
      :current-page="page2"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize2"
      layout=" prev, pager, next"
      :total="total2"
    >
    </el-pagination>

    <!-- 用户水卡 -->
    <div class="mgt-20 mgb-20">用户水卡</div>
    <el-form :inline="true" ref="cardForm" :model="cardForm" label-width="80px">
      <!-- <el-form-item label="所属企业">
        <el-select
          v-model="cardForm.qiye"
          filterable
          clearable
          placeholder="全部"
        >
          <el-option
            v-for="v in qiyeArr"
            :key="v.id"
            :label="v.companyName"
            :value="v.id"
          ></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="所属区域">
        <el-select
          v-model="cardForm.fenqu"
          filterable
          clearable
          placeholder="全部"
        >
          <el-option
            v-for="(v, i) in zoneArr"
            :key="i"
            :label="v.regionName"
            :value="v.id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="getClentCard()">查询</el-button>
        <el-button
          @click="
            cardForm = {};
            getClentCard();
          "
          >重置</el-button
        >
      </el-form-item>
    </el-form>

    <el-table :data="cardTable" style="width: 100%" border>
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="cardId" label="卡号">
        <template slot-scope="scope">
          <span
            v-text="scope.row.cardId ? scope.row.cardId : scope.row.waterCard"
          >
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="水卡类型">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.cardType == 2
                ? '实物卡'
                : scope.row.cardType == 1
                ? '电子卡'
                : scope.row.cardType == 3
                ? '时效电子卡'
                : scope.row.cardType == 4
                ? '时效实物卡'
                : '- -'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="regionName" label="所属分区"> </el-table-column>

      <el-table-column prop="address" label="水卡状态">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.cardStatus == 0
                ? '正常'
                : scope.row.cardStatus == 1
                ? '已挂失'
                : scope.row.cardStatus == 2
                ? '异常'
                : '已失效'
            "
          ></span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="address" label="卡内余额"> </el-table-column> -->
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>

    <!-- 查看滤芯弹框 -->
    <el-dialog
      title="滤芯信息"
      :visible.sync="dialogVisible"
      width="50%"
      center
      top="30vh"
      :close-on-click-modal="false"
    >
      <el-table border :data="filterTable" stripe style="width: 100%">
        <el-table-column prop="filterElementName" label="滤芯名称">
        </el-table-column>
        <el-table-column prop="changeTime" label="更换周期（天）">
        </el-table-column>
        <el-table-column prop="endTime" label="到期时间"> </el-table-column>
        <el-table-column prop="baifen" label="未使用百分比"> </el-table-column>
        <el-table-column prop="address" label="滤芯状态">
          <template slot-scope="scope">
            <span
              v-text="
                scope.row.status === 0
                  ? '停用'
                  : scope.row.status === 1
                  ? '启用'
                  : '- -'
              "
            ></span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">已知晓</el-button>
      </span>
    </el-dialog>
    <div class="mgt-100 flex jcc aic">
      <el-button @click="$router.push('/client/clientList')">已知晓</el-button>
    </div>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import store from "../../store";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      basicTableData: [], //基本信息数组
      orderTableData: [], //订单信息数组
      dialogVisible: false,
      filterTable: [],
      homeTableData: [], //家用净水机
      monthForm: {
        qiye: "",
        fenqu: "",
      },
      cardForm: {
        qiye: "",
        fenqu: "",
      },
      qiyeArr: [],
      zoneArr: [],
      cardTable: [],
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 10, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      staffTable: [], //员工信息
      // 分页数据
      page2: 1, // 当前页，默认
      pageSize2: 10, //每页显示多少条数据，默认
      total2: 50, // 数据总条数
      companyId: null,
    };
  },
  created() {
    console.log(
      "🚀 ~ file: clientDetail.vue:47 ~ created ~ this.$route.query",
      this.$route.query,
      "信息"
    );
    this.basicTableData.push(this.$route.query.info);
    this.getROLE();

    this.getclientOrder();
    this.getEquipment();
    // this.getQiye();
    this.getZone();
    this.getClentCard();
    this.getStaff(); //销售
  },
  methods: {
    getROLE() {
      var token = store.getters.get_token;
      if (token) {
        this.companyId = token.companyId;
      }
    },
    // 客户查销售员工
    getStaff(pageNum) {
      if (!pageNum) {
        this.page2 = 1;
      }
      this.$api.staffClient
        .staffClientListNew({
          pageNum: this.page2,
          pageSize: this.pageSize2,
          customerId: this.basicTableData[0].id,
          companyId: this.companyId,
        })
        .then((res) => {
          if (res.code === 200) {
            this.staffTable = res.data.list;
            this.total2 = res.data.total;
          }
        });
    },
    getClentCard(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }

      this.$api.waterCard
        .cardList({
          pageNum: this.page,
          pageSize: this.pageSize,
          // companyId: this.cardForm.qiye,
          regionId: this.cardForm.fenqu,
          customerPhone: this.basicTableData[0].customerPhone,
          companyId: this.companyId,
        })
        .then((a) => {
          if (a.code === 200) {
            this.cardTable = a.data.list;
            this.total = a.data.total;
          }
        });
    },
    handleLookFilter(row) {
      this.$api.shebei.filter({ id: row.id }).then((res) => {
        if (res.code === 200) {
          this.filterTable = res.data;
          this.filterTable.forEach((v) => {
            v.baifen = this.jindu(v) + "%";
            if (v.changeTime && v.createTime) {
              v.endTime = this.addDaysToDate(v.createTime, v.changeTime);
            } else {
              v.endTime = "- -";
            }
          });
          this.dialogVisible = true;
        }
      });
    },

    addDaysToDate(startDate, days) {
      const startDateObj = new Date(startDate);
      const millisecondsToAdd = days * 24 * 60 * 60 * 1000;

      // 计算相加后的时间（以毫秒为单位）
      const resultTime = startDateObj.getTime() + millisecondsToAdd;

      // 创建新的Date对象来表示相加后的日期

      const resultDate = new Date(resultTime);

      // 格式化日期字符串（年-月-日 时:分:秒）
      const formattedResult = resultDate
        .toISOString()
        .replace("T", " ")
        .slice(0, 19);

      return formattedResult;
    },

    jindu(v) {
      // console.log(v, '进度');
      let startTime = new Date(v.createTime).getTime(); //开始时间
      let endTime = this.GetDateStr(v.changeTime).getTime(); //到期时间
      let currentTime = new Date().getTime(); //现在时间
      var totalTime = endTime - startTime;
      var elapsedTime = currentTime - startTime;
      var progress = (elapsedTime / totalTime) * 100;
      return parseFloat(100 - progress).toFixed(0);
    },

    GetDateStr(AddDayCount) {
      var dd = new Date();
      dd.setDate(dd.getDate() + AddDayCount);
      return dd;
    },

    getDaysBetween(startDateStr, endDateStr) {
      if (startDateStr === this.formatDate(endDateStr)) {
        return 0;
      }
      var startDate = new Date(startDateStr);
      var endDate = new Date(endDateStr);
      var startTimestamp = startDate.getTime();
      var endTimestamp = endDate.getTime();
      var timeDiff = Math.abs(endTimestamp - startTimestamp);
      var dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
      return dayDiff;
    },

    formatDate(dateStr) {
      var date = new Date(dateStr);
      var year = date.getFullYear();
      var month = ("0" + (date.getMonth() + 1)).slice(-2);
      var day = ("0" + date.getDate()).slice(-2);
      var hours = ("0" + date.getHours()).slice(-2);
      var minutes = ("0" + date.getMinutes()).slice(-2);
      var seconds = ("0" + date.getSeconds()).slice(-2);

      var formattedDate =
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;

      return formattedDate;
    },

    getclientOrder() {
      this.$api.client
        .clientOrder({ userId: this.$route.query.info.id })
        .then((res) => {
          if (res.code === 200) {
            this.orderTableData.push(res.data);
          }
        });
    },
    // 客户设备列表
    getEquipment() {
      this.$api.client
        .userEquipment({ userId: this.$route.query.info.id })
        .then((res) => {
          if (res.code === 200) {
            this.homeTableData = res.data;
          }
        });
    },
    // 企业下拉
    getQiye() {
      this.$api.enterprise.enterpriseListPullNew().then((res) => {
        if (res.code === 200) {
          this.qiyeArr = res.data;
        }
      });
    },
    // 分区下拉
    getZone() {
      this.$api.marketing.allZonePull().then((res) => {
        if (res.code === 200) {
          this.zoneArr = res.data;
        }
      });
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getClentCard(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getClentCard(this.page);
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },

    indexMethod2(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.getStaff(this.page2);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange2(val) {
      this.page2 = val;
      this.getStaff(this.page2);
    },
  },
};
</script>

<style lang="scss" scoped>
// table表格标题
/deep/ .el-table__header .cell {
  color: var(--text-main) !important;
  font-weight: 600 !important;
}

/deep/ .el-descriptions__title {
  color: #66b1ff !important;
}
</style>
